import {NgModule} from '@angular/core';
import {NavigationService} from './navigation.service';

@NgModule({
    providers: [NavigationService]
})
export class NavigationServiceModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/service/navigation.module.ts